import { Component, OnInit } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MemberappBaseComponent } from "../groupportal-base/groupportal-base.component";
import {
	AcepSSOService,
	GlobalDomOpsService,
	GlobalDataOpsService,
	CommonOperationsService
} from "@acepteam/globalspack";
import {
	ChapterDetails,
	ChapterInfo
} from "../../../shared/models/chapter-details";
import { DashboardService } from "./dashboard.service";
import { Observable, Observer, Subject, Subscription, of } from "rxjs";
import { group } from "@angular/animations";
import { Group, GroupInfo } from "../../../shared/models/group-portal-data.models";

@Component({
	selector: "app-dashboard  .d-flex.pl-3",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.scss"]
})
export class DashboardComponent extends MemberappBaseComponent {
	//@ViewChild(SassHelperComponent);
	//private sassHelper: SassHelperComponent;
	header: any;
	subscription: Subscription;
	groupInfo: any;
	selectedGroup: Group;
	// constructor(
	//   private process: DashboardService,
	// ) {

	//   this.subscription = this.process.getHeader().subscribe(header => { this.header = header; });
	//   this.process.getOrderAmount().subscribe(orderAmount => { this.orderAmount = orderAmount; });
	//   this.process.getOrderNumber().subscribe(orderNumber => { this.orderNumber = orderNumber; });
	// }

	initSubscriptions() {
		// this.groupPortalDataService.getGroupInfo().subscribe(groupInfo => {this.groupInfo = groupInfo});
		// this.groupPortalDataService.getSelectedGroup().subscribe(selectedGroup => {this.selectedGroup = selectedGroup});
	}

	ngOnInit() {
		//this.loggerService.logInfo(this.groupPortalDataService.memberAppData);

		//reset
		//this.resetForm();

		//subscriptions
	}
	ngAfterViewInit() {

	}

	//   resetForm() {
	//     this.chapterDetails = this.DashboardService.getCurrentChapters();
	//     //this.chaptersService.giveSomeTestData();

	//     this.chapterForm = this.fb.group({
	//       chapters: this.fb.array(
	//         this.chapterDetails.chapters.map(a => this.createItem(a))
	//       )
	//     });

	//     this._setPrimary();
	//   }
}
